import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { ContentTypeMap, IContentProps } from './types';

const useStyles = makeStyles()((theme) => ({
  container: {
    background: theme.palette.background.paper,
  },
  content: {
    overflowY: 'auto',
    overflowWrap: 'anywhere',
    [theme.breakpoints.down('md')]: {
      '.overflow &': {
        overflowY: 'visible',
      },
    },
    '& > *': {
      display: 'flex',
      minHeight: '100%',
      overflow: 'hidden',
    },
  },
}));

const Content: React.FC<React.PropsWithChildren<IContentProps>> = (props) => {
  const { top, bottom, scrollRef, children, onScroll, onChangeYOffset, style, ...rest } = props;
  const { classes } = useStyles();

  const handleOnScroll = () => {
    if (onChangeYOffset) onChangeYOffset(window.pageYOffset);
    if (onScroll) onScroll();
  };

  useEffect(() => {
    window.removeEventListener('scroll', handleOnScroll);
    window.addEventListener('scroll', handleOnScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleOnScroll);
  });

  return (
    <Grid
      {...rest}
      style={style}
      className={classes.container}
      container
      direction="column"
      wrap="nowrap"
      item
      xs
      onScroll={onScroll}
    >
      {top && <Grid item>{top}</Grid>}
      <Grid className={classes.content} ref={scrollRef} onScroll={onScroll} item xs>
        <div>{children}</div>
      </Grid>
      {bottom && <Grid item>{bottom}</Grid>}
    </Grid>
  );
};

export default Content as OverridableComponent<ContentTypeMap>;
